module.exports = __webpack_public_path__ + "static/img/wla.44f6f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/wla.jpg
// module id = BR+F
// module chunks = 0